import React from 'react'

const Pauseicon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
            <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
        </svg>
    )
}

export default Pauseicon
